import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import TextInput from "../../../../components/TextInput";
import { toast } from "react-toastify";
import CocHistoryView from "../../policy/views/coc-history-view";
import Button from "../../../../components/Button";
import { cn } from "../../../../utils/style";
function ShafafiyaReportForm() {
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState("");
  const [submittedEid, setSubmittedEid] = useState(null);
  const handleSearchClick = () => {
    if (searchTerm.trim().length > 0) {
      setSubmittedEid(searchTerm.trim());
    } else {
      toast.error("Please enter an Emirates ID to search");
    }
  };
  return (
    <div className="mt-6">
      <div
        className={cn(
          "grid gap-x-6 gap-y-8 grid-cols-12 bg-white p-6 rounded-lg shadow-sm border border-gray-200",
        )}
      >
        <div className="col-span-12">
          <h4 className="text-md font-medium text-gray-900 mb-1">
            {t("Historical COC Lookup")}
          </h4>
          <p className="text-sm text-gray-500 mb-4">
            {t(
              "Enter an Emirates ID to fetch history directly from Shafafiya SOAP API.",
            )}
          </p>
        </div>

        <div className="col-span-12 md:col-span-4">
          <TextInput
            name="search-term"
            label={t("Emirates ID")}
            id="search-term"
            placeholder={t("784-XXXX-XXXXXXX-X")}
            get={searchTerm}
            set={setSearchTerm}
          />
        </div>

        <div className="col-span-12 flex gap-3">
          <Button onClick={handleSearchClick}>{t("Search History")}</Button>
          {submittedEid && (
            <Button
              secondary={true}
              onClick={() => {
                setSubmittedEid(null);
                setSearchTerm("");
              }}
            >
              {t("Clear Results")}
            </Button>
          )}
        </div>
      </div>

      {submittedEid && (
        <div className="mt-8">
          <CocHistoryView
            emiratesId={submittedEid}
            onClose={() => {
              setSubmittedEid(null);
              setSearchTerm("");
            }}
          />
        </div>
      )}
    </div>
  );
}
export default ShafafiyaReportForm;
